import { render, staticRenderFns } from "./userinfo-school.vue?vue&type=template&id=0d025db8&scoped=true"
import script from "./userinfo-school.vue?vue&type=script&lang=js"
export * from "./userinfo-school.vue?vue&type=script&lang=js"
import style0 from "./userinfo-school.vue?vue&type=style&index=0&id=0d025db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d025db8",
  null
  
)

export default component.exports